import { get } from 'app/utils/axios/kheti'
import ApiResponse from 'app/models/apiResponse'
import { DemoMaterialProduct } from 'app/models/RequestFlow'

const fetchDemoMaterialProducts = async (
  page: number,
  page_size = 10,
  name?: string,
  /** Comma-separated brand names, e.g. `GAPL,AJAY AGRITECH` */
  brand?: string,
) => {
  try {
    const params: Record<string, string> = {
      page: page.toString(),
      page_size: page_size.toString(),
    }
    if (name?.trim()) params.name = name.trim()
    if (brand?.trim()) params.brand = brand.trim()

    const response = await get<ApiResponse<DemoMaterialProduct>>(
      '/approvals/v1/demo-material-issuance/products',
      params,
    )
    return response
  } catch (e) {
    console.log('Error fetching demo material products:', e)
    return e
  }
}

export default fetchDemoMaterialProducts
